export default "__VITE_ASSET__CltrrR0Q__"